var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downWrap"},[_c('img',{staticClass:"img",attrs:{"src":require("../images/shareBg.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":_vm.toStore}},[_vm._v("下载慧殡葬APP")]),_vm._v(" "),_c('v-downTip',{attrs:{"popShow":_vm.popShow}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-78b5678e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/share/sharedown.vue
// module id = null
// module chunks = 